module.exports = __webpack_public_path__ + "img/amazonia.6276ed43.png";